export default __webpack_public_path__ + "static/media/ic-arrow-down.d6d95876.svg";